import { PAGES } from 'constants/routes'
import { useAppSelector } from 'hooks/use-app-selector'
import { useRouter } from 'next/router'
import Script from 'next/script'
import { selectIsAiSubscriptionActive } from 'store/slices/subscription/subscription'

export const TawkChat = () => {
  const isAiSubscriber = useAppSelector(selectIsAiSubscriptionActive)
  const router = useRouter()

  // Don't render on admin pages
  if (router.pathname.startsWith(PAGES['/admin/'])) {
    return null
  }

  if (!isAiSubscriber) {
    return null
  }

  return (
    <Script
      id="tawk-to-init"
      type="text/javascript"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
              var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
              (function(){
                var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
                s1.async=true;
                s1.src='https://embed.tawk.to/64a14b1dcc26a871b025d82c/1h4b0qr06';
                s1.charset='UTF-8';
                s1.setAttribute('crossorigin','*');
                s0.parentNode.insertBefore(s1,s0);
              })();
          `,
      }}
    />
  )
}
